<template>
    <div class="DshTextMultiple ycFormItem">
        <Input
            class="DshTextMultiple-control"
            v-model="text"
            :placeholder="$showPlaceholder(canEdit, propsObj) ? `请输入${propsObj._name}` : ''"
            :type="'text'"
            :readonly="!canEdit"
            :disabled="propsObj.canEdit === false"
            :clearable="true"
            :size="propsObj._size"
        />
        <dsh-buttons
            class="DshTextMultiple-create"
            :list="$getOperationList(['createTag'])"
            @click="$dispatchEvent($event)"
        ></dsh-buttons>

        <!-- 标签列表 -->
        <dsh-tags
            class="dsh-margin-top5"
            :list="value[propsObj._key]"
            @delete="$dispatchEvent(operationMap.deleteTag, arguments)"
        ></dsh-tags>
    </div>
</template>

<script>
    import controlMixin from "../controlMixin.js";

    export default {
        name: "DshTextMultiple",
        mixins: [controlMixin],
        props: {},
        data () {
            return {
                text: "",

                operationMap: {
                    createTag: {
                        name: "添加",
                        type: "createTag",
                        size: "default",
                        event: "createTag"
                    },
                    deleteTag: {
                        name: "删除",
                        type: "deleteTag",
                        event: "deleteTag"
                    }
                }
            };
        },
        computed: {},
        created () {},
        methods: {
            createTag () {
                if (this.text && this.text.trim()) {
                    if (this.value[this.propsObj._key].some(item => item === this.text.trim())) {
                        this.$Message.error({
                            content: `搜索文字 "${this.text.trim()}" 已存在！`,
                            duration: 5
                        });
                    } else {
                        this.value[this.propsObj._key].push(this.text.trim());
                        this.change();
                    }

                }
                this.text = "";
            },
            // 删除
            deleteTag (operationItem, params) {
                this.change();
            }
        }
    };
</script>

<style lang="less" scoped>
    .DshTextMultiple {
        width: 100%;
        &-control {
            display: inline-block;
            width: calc(100% - 65px);
        }
        &-create {
            display: inline-block;
            width: 60px;
        }
    }
</style>
<style lang="less">
    .DshTextMultiple {

    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/DshTextMultiple.vue